export enum AccommodationListTooltip {
	'Main' = 'Main',
	'Expanded' = 'Expanded'
}
